import { ControlTest } from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import React, { createContext, ReactNode, useContext, useState } from 'react'

type CurrentControlTestContextType = {
  currentControlTest?: ControlTest
  setCurrentControlTest: React.Dispatch<
    React.SetStateAction<ControlTest | undefined>
  >
}

export const useCurrentControlTestContext = (): CurrentControlTestContextType =>
  useContext(CurrentControlTestContext)

const CurrentControlTestContext = createContext<CurrentControlTestContextType>({
  currentControlTest: undefined,
  setCurrentControlTest: () => null,
})

export const CurrentControlTestProvider = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const [currentControlTest, setCurrentControlTest] = useState<ControlTest>()

  return (
    <CurrentControlTestContext.Provider
      value={{
        currentControlTest,
        setCurrentControlTest,
      }}
    >
      {children}
    </CurrentControlTestContext.Provider>
  )
}
